import {
  Button,
  Card,
  Dialog,
  Input,
  Message,
  NumberPicker,
  Select,
} from '@alifd/next';
import {
  Checkbox,
  Form,
  Image,
  InputNumber,
  Space,
  TimePicker,
  Typography,
  Upload,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import axiosWithAuth from '@/lib/axios';

import client from '../../../../lib/feathers';
import { handleImageUpload } from './helpers';
import styles from './index.module.scss';

const city = [
  '台北市',
  '基隆市',
  '新北市',
  '連江縣',
  '宜蘭縣',
  '新竹市',
  '新竹縣',
  '桃園市',
  '苗栗縣',
  '台中市',
  '彰化縣',
  '南投縣',
  '嘉義市',
  '嘉義縣',
  '雲林縣',
  '台南市',
  '高雄市',
  '澎湖縣',
  '金門縣',
  '屏東縣',
  '台東縣',
  '花蓮縣',
];
const faceDevice = ['TONNET', 'SOYAL', '其他'];

const Option = Select.Option;

const BasicInformation = () => {
  const [form] = Form.useForm();
  const standbyActiveField = Form.useWatch('isActive', form);
  const uploadFile = useRef(null);
  const uploadParkFile = useRef(null);
  const user = useSelector((state) => state.user);
  const communityData = client.service('communityData');
  const accountingSubjects = client.service('accountingSubjects');
  const [communityArr, setCommunityArr] = useState([]);
  const [uploadCommunityImage, setUploadCommunityImage] = useState(null);
  const [uploadParkImage, setUploadParkImage] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [editCommunityDialog, setEditCommunityDialog] = useState(false);
  const [manager, setManager] = useState(); // 紀錄管理者權限
  const [test, setTest] = useState();

  const isLoadingInitValue = {
    loading: false,
    dataIndex: undefined,
  };
  const [isLoading, setIsLoading] = useState(isLoadingInitValue);

  useEffect(() => {
    if (user.userGroup.key) {
      setManager(user.userGroup.name); // 紀錄管理者權限
    }
  }, [user]);

  useEffect(() => {
    communityData.find({ query: {} }).then((result) => {
      setCommunityArr(result.data[0]);
    });
  }, [isUpdate, communityData, accountingSubjects]);

  const readAndConvertFileToImageData = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = function () {
        const imageUrl = reader.result;
        const image = { file, name: file.name, path: imageUrl };
        resolve(image);
      };

      reader.onerror = function (error) {
        reject(error);
      };

      reader.readAsDataURL(file);
    });
  };

  const handleImageChange = async (event, dataIndex) => {
    const file = event.target.files[0];
    const isValidFileSize = file.size / 1024 / 1024 < 20;
    if (!isValidFileSize) {
      Message.error('上傳檔案不能超過20MB');
      return;
    }

    try {
      const image = await readAndConvertFileToImageData(file);
      const setUploadImageFunction =
        dataIndex === 'communityImage'
          ? setUploadCommunityImage
          : setUploadParkImage;
      setUploadImageFunction(image);
      setIsLoading(isLoadingInitValue);
    } catch (error) {
      console.error(error);
    }
  };

  const handleUploadResidentialManual = async ({ file, onSuccess }) => {
    const data = new FormData();
    data.append('files', file);
    console.log(file, 'files');
    try {
      const res = await axios.post('/newUploads', data, {
        headers: {
          authorization: window.localStorage.getItem('feathers-jwt'),
        },
        params: {
          type: 'communityData',
          isConvertPng: true,
        },
      });
      if (onSuccess) {
        console.log(res);
        onSuccess(res.data[0]);
      }
    } catch (err) {
      console.error({ err });
    }
  };

  const onFinish = async ({
    longitude,
    latitude,
    zoom,
    busUrl,
    trainUrl,
    MRTUrl,
    isDisplayMRTUrl,
    isActive,
    afterMilliseconds,
    scheduleTime,
    urgentTime,
    ...rest
  }) => {
    setIsLoading({ loading: true, dataIndex: 'formSubmit' });

    const oldCommunityImage = communityArr.files;
    const oldParkImage = communityArr.parkingImage;

    const communityImage = await handleImageUpload(
      oldCommunityImage,
      uploadCommunityImage
    );
    const parkImage = await handleImageUpload(oldParkImage, uploadParkImage);

    const locationInfo = { longitude, latitude, zoom };
    const screenStandby = {
      isActive,
      afterMilliseconds: afterMilliseconds * 60000,
    };

    const data = {
      ...rest,
      lifeService: {
        locationInfo,
        busUrl,
        trainUrl,
        MRT: {
          url: MRTUrl,
          isDisplay: isDisplayMRTUrl,
        },
      },
      screenStandby,
      files: communityImage,
      parkingImage: parkImage,
      scheduleTime: moment(scheduleTime).format('HH:mm'),
      urgentTime:
        moment(urgentTime).valueOf() - moment().startOf('day').valueOf(),
    };

    communityData.patch(communityArr._id, data).then(() => {
      Message.success('修改成功');
      setIsLoading(isLoadingInitValue);
      setEditCommunityDialog(false);
      setIsUpdate((pre) => !pre);
    });
  };

  const closeEditDialog = () => {
    setEditCommunityDialog(false);
    form.resetFields();
  };

  const clearImage = (dataIndex) => {
    const setUploadImageFunction =
      dataIndex === 'communityImage'
        ? setUploadCommunityImage
        : setUploadParkImage;
    setUploadImageFunction(null);
  };

  return (
    <>
      {/* 20220708暫時註解 */}
      {/* <Button
        className={communityArr ? styles.buttonAddNone : styles.buttonAddBlock}
        onClick={() => {
          setAddCommunityDialog(true);
        }}
      >
        新增社區
      </Button> */}
      <Button
        className={communityArr ? styles.buttonAddBlock : styles.buttonAddNone}
        onClick={() => {
          const {
            lifeService: {
              locationInfo: { longitude, latitude, zoom },
              busUrl,
              trainUrl,
              MRT: { url, isDisplay },
            },
            screenStandby: { isActive, afterMilliseconds },
          } = communityArr;
          form.setFieldsValue({
            ...communityArr,
            scheduleTime: moment(communityArr.scheduleTime, 'HH:mm'),
            urgentTime: moment(
              moment(
                moment().startOf('day').valueOf() +
                  parseInt(communityArr.urgentTime, 10)
              ).format('mm:ss'),
              'mm:ss'
            ),
            longitude,
            latitude,
            zoom,
            busUrl,
            trainUrl,
            MRTUrl: url,
            isDisplayMRTUrl: isDisplay,
            isActive,

            afterMilliseconds: afterMilliseconds / 60000,
          });
          setEditCommunityDialog(true);
          setUploadCommunityImage(communityArr.files);
          setUploadParkImage(communityArr.parkingImage);
        }}
      >
        編輯社區
      </Button>

      {/* 編輯 */}
      <Dialog
        hasMask
        className={styles.dialog}
        visible={editCommunityDialog}
        onClose={closeEditDialog}
        footer={
          <Space>
            <Button
              type="primary"
              loading={
                isLoading.loading && isLoading.dataIndex === 'formSubmit'
              }
              onClick={() => form.submit()}
            >
              確認
            </Button>
            <Button onClick={closeEditDialog}>取消</Button>
          </Space>
        }
      >
        <div>
          <h3>編輯社區資料</h3>
          <Form layout="vertical" onFinish={onFinish} form={form}>
            <Form.Item
              name="name"
              label="社區名稱"
              rules={[
                {
                  required: true,
                  message: '請輸入社區名稱',
                },
              ]}
            >
              <Input maxLength={6} />
            </Form.Item>
            <Form.Item
              name="englishName"
              label="英文名稱"
              rules={[
                {
                  required: true,
                  message: '請輸入社區英文名稱',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="city"
              label="城市"
              rules={[
                {
                  required: true,
                  message: '請選擇城市',
                },
              ]}
            >
              <Select>
                {city.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="address"
              label="地址"
              rules={[
                {
                  required: true,
                  message: '請輸入地址',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name="phone"
              label="電話"
              rules={[
                {
                  required: true,
                  message: '請輸入電話',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item label="社區照片">
              <Space wrap>
                <Button
                  loading={
                    isLoading.loading &&
                    isLoading.dataIndex === 'communityImage'
                  }
                  onClick={() => {
                    uploadFile.current.click();
                  }}
                >
                  {uploadCommunityImage ? '更換附件' : '上傳附件'}
                </Button>
                {uploadCommunityImage ? (
                  <>
                    <Typography.Text type="secondary">
                      {uploadCommunityImage.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => clearImage('communityImage')}
                      className={styles.clearPreviewImageButton}
                    >
                      清除
                    </Button>
                  </>
                ) : null}
              </Space>
              <input
                ref={uploadFile}
                type="file"
                className={styles.hidden}
                onChange={(event) => {
                  if (event.target.files.length) {
                    setIsLoading({
                      loading: true,
                      dataIndex: 'communityImage',
                    });
                    handleImageChange(event, 'communityImage');
                  }
                }}
                accept="image/png, image/jpeg"
              />
              {uploadCommunityImage ? (
                <Image
                  className={styles.photo}
                  src={uploadCommunityImage.path}
                  alt="圖片"
                />
              ) : null}
            </Form.Item>
            <Form.Item label="車位照片">
              <Space wrap>
                <Button
                  loading={
                    isLoading.loading && isLoading.dataIndex === 'parkImage'
                  }
                  onClick={() => {
                    uploadParkFile.current.click();
                  }}
                >
                  {uploadParkImage ? '更換附件' : '上傳附件'}
                </Button>
                {uploadParkImage ? (
                  <>
                    <Typography.Text type="secondary">
                      {uploadParkImage.name}
                    </Typography.Text>
                    <Button
                      text
                      onClick={() => clearImage('parkImage')}
                      className={styles.clearPreviewImageButton}
                    >
                      清除
                    </Button>
                  </>
                ) : null}
              </Space>
              <input
                ref={uploadParkFile}
                type="file"
                className={styles.hidden}
                onChange={(event) => {
                  if (event.target.files.length) {
                    setIsLoading({ loading: true, dataIndex: 'parkImage' });
                    handleImageChange(event, 'parkImage');
                  }
                }}
                accept="image/png, image/jpeg"
              />
              {uploadParkImage ? (
                <Image
                  className={styles.photo}
                  src={uploadParkImage.path}
                  alt="圖片"
                />
              ) : null}
            </Form.Item>
            <Form.Item
              name="bio"
              label="社區簡介"
              rules={[
                {
                  required: true,
                  message: '請輸入社區簡介',
                },
              ]}
            >
              <Input.TextArea maxLength={500} rows={6} hasLimitHint />
            </Form.Item>
            <Form.Item
              name="residentialManual"
              label="上傳住戶教學手冊"
              valuePropName="fileList"
              getValueFromEvent={(e) => {
                return e.fileList;
              }}
            >
              <Upload
                accept=".pdf"
                customRequest={handleUploadResidentialManual}
                maxCount={1}
              >
                <Button>上傳</Button>
              </Upload>
            </Form.Item>
            <Form.Item
              name="scheduleTime"
              label="每日推播時間"
              rules={[
                {
                  required: true,
                  message: '請輸入每日推播時間',
                },
              ]}
            >
              <TimePicker format="HH:mm" />
            </Form.Item>
            <Form.Item
              name="urgentTime"
              label="緊急通知時間"
              rules={[
                {
                  required: true,
                  message: '請輸入緊急通知時間',
                },
              ]}
            >
              <TimePicker format="mm分鐘ss秒" />
            </Form.Item>

            <Form.Item
              label="經度"
              name="longitude"
              rules={[
                {
                  required: true,
                  message: '請輸入經度',
                },
              ]}
            >
              <InputNumber
                placeholder="請輸入經度"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item
              label="緯度"
              name="latitude"
              rules={[
                {
                  required: true,
                  message: '請輸入緯度',
                },
              ]}
            >
              <InputNumber
                placeholder="請輸入緯度"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item
              label="地圖縮放值 (zoom)"
              name="zoom"
              rules={[
                {
                  required: true,
                  message: '請輸入地圖縮放值',
                },
              ]}
            >
              <InputNumber
                placeholder="請輸入地圖縮放值"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item
              label="公車連結"
              name="busUrl"
              rules={[
                {
                  required: true,
                  message: '請輸入公車連結',
                },
              ]}
            >
              <Input
                placeholder="請輸入公車連結"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item
              label="火車連結"
              name="trainUrl"
              rules={[
                {
                  required: true,
                  message: '請輸入火車連結',
                },
              ]}
            >
              <Input
                placeholder="請輸入火車連結"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item
              label="捷運連結"
              name="MRTUrl"
              dependencies={['isDisplayMRTUrl']}
              rules={[
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (
                      (value && getFieldValue('isDisplayMRTUrl') === true) ||
                      getFieldValue('isDisplayMRTUrl') === false
                    ) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error('請輸入捷運連結'));
                  },
                }),
              ]}
            >
              <Input
                placeholder="請輸入捷運連結"
                className={styles.fullWidthInputNumber}
              />
            </Form.Item>
            <Form.Item name="isDisplayMRTUrl" valuePropName="checked">
              <Checkbox>是否開放住戶使用捷運連結</Checkbox>
            </Form.Item>

            <Form.Item name="isActive" valuePropName="checked">
              <Checkbox>是否啟用待機功能</Checkbox>
            </Form.Item>
            <Form.Item
              name="afterMilliseconds"
              label="進入待機畫面時間(單位：分鐘)"
              dependencies={['isActive']}
              rules={[
                {
                  validator: (_rules, value) => {
                    if (standbyActiveField && !value) {
                      return Promise.reject(new Error('請設定進入待機時間'));
                    } else if (value < 1) {
                      return Promise.reject(new Error('請輸入大於等於1的值'));
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <InputNumber
                placeholder="請輸入進入待機的時間"
                className={styles.fullWidthInputNumber}
                formatter={(value) => {
                  const formattedValue = Math.round(value);
                  return formattedValue;
                }}
              />
            </Form.Item>
            <Form.Item name="showPackageRecipient" valuePropName="checked">
              <Checkbox>是否啟用收件人功能</Checkbox>
            </Form.Item>
            {manager === 'superAdmin' && (
              <>
                <Form.Item
                  name="scheduleDelete"
                  label="資料庫清除時間(天)"
                  rules={[
                    {
                      required: true,
                      message: '請輸入清除時間',
                    },
                  ]}
                >
                  <NumberPicker format={(val) => `${val}天`} />
                </Form.Item>
                <Form.Item
                  name="faceDevice"
                  label="辨識設備"
                  rules={[
                    {
                      required: true,
                      message: '辨識設備',
                    },
                  ]}
                >
                  <Select>
                    {faceDevice.map((item) => (
                      <Option key={item} value={item}>
                        {item}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}
          </Form>
        </div>
      </Dialog>

      {/* Tab資料顯示 */}
      {communityArr ? (
        <Card free>
          <Card.Content>
            <h2>
              社區名稱:
              <span className={styles.content}>{communityArr.name}</span>
            </h2>
            <h2>
              社區英文名稱:
              <span className={styles.content}>{communityArr.englishName}</span>
            </h2>
            <h2>
              城市:
              <span className={styles.content}>{communityArr.city}</span>
            </h2>
            <h2>
              地址:
              <span className={styles.content}>{communityArr.address}</span>
            </h2>
            <h2>
              電話:
              <span className={styles.content}>{communityArr.phone}</span>
            </h2>
            <h2>
              社區簡介:
              <span className={styles.content}>{communityArr.bio}</span>
            </h2>
            <h2>
              社區照片:
              {communityArr.files && <br />}
              <span className={styles.content}>
                {communityArr.files ? (
                  <Image
                    className={styles.img}
                    src={communityArr.files.path}
                    alt="圖片"
                  />
                ) : (
                  '尚無照片'
                )}
              </span>
            </h2>
            <h2>
              車位照片:
              {communityArr.parkingImage && <br />}
              <span className={styles.content}>
                {communityArr.parkingImage ? (
                  <Image
                    className={styles.img}
                    src={communityArr.parkingImage.path}
                    alt="圖片"
                  />
                ) : (
                  '尚無照片'
                )}
              </span>
            </h2>
            <h2>
              每日推播時間:
              <span className={styles.content}>
                {communityArr.scheduleTime !== 'Invalid date'
                  ? communityArr.scheduleTime
                  : '未設定'}
              </span>
            </h2>
            <h2>
              緊急通知時間:
              <span className={styles.content}>
                {communityArr.urgentTime !== 'Invalid date'
                  ? moment(communityArr.urgentTime).format('mm分鐘ss秒')
                  : '未設定'}
              </span>
            </h2>

            <h2>生活服務相關：</h2>
            <div className={styles.multipleContentContainer}>
              <h3>
                經度:
                <span className={styles.content}>
                  {communityArr.lifeService?.locationInfo?.longitude}
                </span>
              </h3>
              <h3>
                緯度:
                <span className={styles.content}>
                  {communityArr.lifeService?.locationInfo?.latitude}
                </span>
              </h3>
              <h3>
                地圖縮放值 (zoom):
                <span className={styles.content}>
                  {communityArr.lifeService?.locationInfo?.zoom}
                </span>
              </h3>
              <h3>
                公車連結:
                <span className={styles.content}>
                  {communityArr.lifeService?.busUrl}
                </span>
              </h3>
              <h3>
                火車連結:
                <span className={styles.content}>
                  {communityArr.lifeService?.trainUrl}
                </span>
              </h3>
              <h3>
                捷運連結:
                <span className={styles.content}>
                  {communityArr.lifeService?.MRT.isDisplay
                    ? communityArr.lifeService?.MRT.url
                    : '尚未開放住戶使用，若要進行修改，請按編輯社區'}
                </span>
              </h3>
            </div>

            <h2>待機畫面設定：</h2>
            <div className={styles.multipleContentContainer}>
              <h3>
                是否啟用待機功能:
                <span className={styles.content}>
                  {communityArr.screenStandby?.isActive ? '是' : '否'}
                </span>
              </h3>
              <h3>
                多久後進入待機畫面(單位：分鐘):
                <span className={styles.content}>
                  {communityArr.screenStandby?.afterMilliseconds
                    ? Math.round(
                        communityArr.screenStandby?.afterMilliseconds / 60000
                      )
                    : '尚未設定'}
                </span>
              </h3>
            </div>
            <h2>郵件/寄物設定：</h2>
            <div className={styles.multipleContentContainer}>
              <h3>
                是否啟用收件人功能:
                <span className={styles.content}>
                  {communityArr.showPackageRecipient ? '是' : '否'}
                </span>
              </h3>
            </div>
            {manager === 'superAdmin' && (
              <>
                <h2>
                  資料庫清除時間:
                  <span className={styles.content}>
                    每日凌晨四點刪除
                    {communityArr.scheduleDelete
                      ? communityArr.scheduleDelete
                      : 0}
                    天以前通知記錄＆訪客歷史紀錄＆BA使用記錄
                  </span>
                </h2>
                <h2>
                  辨識設備:
                  <span className={styles.content}>
                    {communityArr?.faceDevice
                      ? communityArr.faceDevice
                      : '未設定'}
                  </span>
                </h2>
              </>
            )}
          </Card.Content>
        </Card>
      ) : null}
    </>
  );
};

export default BasicInformation;
